<template>
    <p-search-screen
        title="Course Requests"
        api-destination="courserequests"
        edit-key="courseRequestId"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        :edit-url-func="item => `/courserequests/${item.courseRequestId}`"
        add-new-button
        ref="search"
    >
        <template v-slot:actionButtons>
            <p-button
                @click="workRequests"
                variant="outline-primary"
                :disabled="filters.showInActive"
            >
                Work Requests
            </p-button>
            <shelfTag></shelfTag>
            <p-button
                variant="outline-primary"
                @click="$router.push('/courserequests/importlog')"
            >
                Import Log
            </p-button>
        </template>

        <template v-slot:filters>
            <h4 class="m-0 pb-3">Filters</h4>
            <!-- no-body allows for us to set smaller padding -->
            <p-card class="mb-2 px-2 py-2" no-body>
                <p-filter-select
                    :options="filterOptions.terms"
                    label="Terms"
                    v-model="filters.termIds"
                />
            </p-card>
            <p-card class="mb-2 px-2 py-2" no-body>
                <p-filter-select
                    :options="filterOptions.instructors"
                    label="Instructors"
                    v-model="filters.instructorNames"
                />
            </p-card>

            <p-card class="mb-2 px-2 py-2" no-body>
                <p-filter-select
                    :options="filterOptions.departments"
                    label="Departments"
                    v-model="filters.courseDepartmentNames"
                />
            </p-card>

            <p-card class="mb-2 px-2 py-2" no-body>
                <p-filter-select
                    :options="filterOptions.courses"
                    label="Courses"
                    v-model="filters.courseNames"
                />
            </p-card>
            <p-card class="mb-2 px-2 py-2" no-body>
                <p-filter-select
                    :options="filterOptions.sections"
                    label="Sections"
                    v-model="filters.sectionNames"
                />
            </p-card>
        </template>
        <template v-slot:belowSearch>
            <b-row>
                <b-col class="d-flex align-items-center gap-3">
                <p-checkbox
                    label="Open"
                    v-model="filters.open"
                />
                <p-checkbox
                    label="Completed"
                    v-model="filters.completed"
                />
                <p-checkbox
                    label="Incoming"
                    v-model="filters.incoming"
                />
                <p-checkbox
                    label="Closed"
                    v-model="filters.closed"
                />
                </b-col>
            </b-row>
        </template>
    </p-search-screen>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import shelfTag from '../../components/ShelfTag.vue';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            index: 0,
            filterName: 'CourseRequestsFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'termdepartmentcoursesection',
                sortDesc: true,
                searchBy: 'All',
                instructorNames: [],
                courseDepartmentNames: [],
                courseNames: [],
                termIds: [],
                sectionNames: [],
                open:true,
                completed:true,
                incoming:true,
                closed: false
            },
            filterBy: [
                'All',
                'Description',
                'Catalog #',
                'ISBN',
                'Barcode',
                'Book Key'
            ],
            filterOptions: {
                terms: [],
                instructors: [],
                departments: [],
                courses: [],
                sections: []
            },
            fields: [
                {
                    key: 'termDepartmentCourseSection',
                    label: 'Term/Dept/Course/Sec',
                    sortable: true
                },
                {
                    key: 'instructor',
                    sortable: true
                },
                {
                    key: 'courseDescription',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'adoptionStatus',
                    sortable: true
                }
            ]
        };
    },
    computed: {
        // Only the filters that narrow the result set; paging and sorting don't change the filter options.
        filterOptionsParameters() {
            return {
                automatic: this.filters.automatic,
                searchBy: this.filters.searchBy,
                open: this.filters.open,
                completed: this.filters.completed,
                incoming: this.filters.incoming,
                closed: this.filters.closed,
                termIds: this.filters.termIds,
                instructorNames: this.filters.instructorNames,
                courseDepartmentNames: this.filters.courseDepartmentNames,
                courseNames: this.filters.courseNames,
                sectionNames: this.filters.sectionNames
            };
        },
        // Serialized so the watcher only fires when a value actually changes.
        filterOptionsKey() {
            return JSON.stringify(this.filterOptionsParameters);
        }
    },
    watch: {
        filterOptionsKey: {
            handler() {
                this.debouncedLoadFilterOptions();
            },
            immediate: true
        }
    },
    methods: {
        async loadFilterOptions() {
            // Overlapping requests can resolve out of order, so only the latest one is applied.
            const requestToken = ++this.filterOptionsRequestToken;
            const response = await axios.get('courserequests/filteroptions', {
                params: this.filterOptionsParameters
            });
            if (requestToken !== this.filterOptionsRequestToken)
                return;

            this.filterOptions = response.data;
        },
        workRequests: function() {
            axios
                .get('courserequests/getidlist', {
                    params: this.$refs.search.getQueryParameters()
                })
                .then(resp => {
                    var ids = resp.data;
                    this.$router.push({
                        name: 'workcourserequests',
                        state: { ids }
                    });
                });
        }
    },
    beforeCreate() {
        // Set up before the immediate filterOptionsKey watcher runs during create.
        this.filterOptionsRequestToken = 0;
        this.debouncedLoadFilterOptions = debounce(() => this.loadFilterOptions(), 300);
    },
    beforeUnmount() {
        this.debouncedLoadFilterOptions.cancel();
    },
    components: {
        shelfTag
    }
};
</script>